export const CITATION_MARKER_PREFIX = "%%%CITATION_";
export const CITATION_MARKER_SUFFIX = "_%%%";
export const CITATION_NODE_TYPE = "citation";
